module.exports = __webpack_public_path__ + "static/img/banner-logo-global.796a1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/taxcellent/banner-logo-global.png
// module id = TTLj
// module chunks = 34